import React from 'react';
import { ModelInfo } from '../../types';

interface ModelInfoCardProps {
  modelInfo: ModelInfo | null;
  currentModelPath: string;
}

// Helper to format date string
const formatDate = (isoString: string | undefined) => {
  if (!isoString) return 'N/A';
  try {
    return new Date(isoString).toLocaleString();
  } catch (e) {
    return isoString; // Return original string if formatting fails
  }
};

export const ModelInfoCard: React.FC<ModelInfoCardProps> = ({ modelInfo, currentModelPath }) => {
  if (!modelInfo) {
    return <p>Keine Modellinformationen verfügbar.</p>;
  }

  return (
    <div className="model-info-card card">
        <h2><span className="icon">🔧</span> {modelInfo.name || 'Modell'} Informationen</h2>
        <p className="path-source">Geladen von: <span className="path-display">{currentModelPath}</span></p>
        <div className="info-grid">
            <div><strong>Original-Name (aus Info):</strong> {modelInfo.name || 'N/A'}</div>
            <div><strong>Typ:</strong> {modelInfo.type || 'N/A'}</div>
            <div><strong>Trainings-Samples:</strong> {modelInfo.training_samples ?? 'N/A'}</div>
            <div><strong>Erstellt am:</strong> {formatDate(modelInfo.created_at)}</div>
            <div><strong>Passwortgeschützt:</strong> {modelInfo.has_password ? 'Ja' : 'Nein'}</div>
            <div><strong>Warnung:</strong> {modelInfo.warning || 'Keine'}</div>

            <div className="info-section full-width">
                <strong>Originale Features ({modelInfo.original_features?.length || 0}):</strong>
                <ul className="feature-list">
                    {modelInfo.original_features?.map(f => <li key={f}>{f}</li>) ?? <li>Keine</li>}
                </ul>
            </div>

            <div className="info-section full-width">
                 <strong>Finale Features nach Encoding ({modelInfo.final_feature_names?.length || 0}):</strong>
                 <ul className="feature-list">
                    {modelInfo.final_feature_names?.map(f => <li key={f}>{f}</li>) ?? <li>Keine</li>}
                </ul>
            </div>

             <div className="info-section full-width">
                 <strong>Zielvariablen ({modelInfo.target_variables?.length || 0}):</strong>
                 <ul className="feature-list">
                     {modelInfo.target_variables?.map(t => <li key={t}>{t}</li>) ?? <li>Keine</li>}
                 </ul>
             </div>

            {/* Optionally display parameters - might be very long */}
             {/* <div className="info-section full-width">
                 <strong>Parameter:</strong>
                 <pre>{JSON.stringify(modelInfo.parameters, null, 2)}</pre>
             </div> */}
        </div>
    </div>
  );
}; 